
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'Error',
    props: {
      title: {
        type: String,
        required: true,
      },
      message: {
        type: String,
      },
      buttonText: {
        type: String,
      },
      path: {
        type: String,
        default: '/',
      },
    },
  })
